export default "__VITE_ASSET__BwKqc41G__"